import React from "react";

import {
  Box,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
} from "@mui/material";

const RentalSuccessModal = ({
  orderSuccessPopup,
  includedHrsDay,
  handleChatMessage,
  handleCallToAction,
}) => {
  return (
    <Box>
      <Dialog open={orderSuccessPopup} aria-labelledby="draggable-dialog-title">
        <Box
          className="session-expire"
          sx={{ padding: { xs: "1.5rem !important", md: "2rem !important" } }}
        >
          <DialogContent sx={{ padding: "0" }}>
            <DialogContentText
              sx={{
                color: "#fff",
                fontSize: { xs: "15px", md: "20px" },
                padding: "0 !important",
              }}
            >
              <Box
                sx={{
                  color: "#faa61a",
                  mb: 2,
                }}
              >
                Note:
                <Box
                  component={"span"}
                  sx={{
                    color: "#fff",
                    marginLeft: "7px",
                  }}
                >
                  This equipment may be run for up to {includedHrsDay} hours per
                  day.
                </Box>
              </Box>{" "}
              Thank you, you will not be charged until the owner of this
              equipment approves your rental request. Keep an eye on your email
              for confirmation. Also, please reach out to the owner directly at
              this
              <Box
                component={"span"}
                sx={{
                  textDecoration: "underline",
                  color: "#fba618",
                  cursor: "pointer",
                  marginLeft: "7px",
                }}
                onClick={handleChatMessage}
              >
                link
              </Box>{" "}
              with questions. Make sure you have your notifications turned on in
              your GoEquipMe settings.
            </DialogContentText>
          </DialogContent>
          <DialogActions
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              mt: 1,
            }}
          >
            <Button
              className=""
              sx={{
                display: "flex",
                justifyContent: "center",
                backgroundColor: "#2e7d32 !important",
                color: "#fff !important",
                padding: "6px 50px 6px 50px",
                borderRadius: "7px",
                fontFamily: "GothamBold !important",
                fontSize: "20px !important",
                cursor: "pointer",
              }}
              onClick={handleCallToAction}
            >
              OK
            </Button>
          </DialogActions>
        </Box>
      </Dialog>
    </Box>
  );
};

export default RentalSuccessModal;
